import { CcModal } from "@utp/components-react";
import { Button } from "@utp/react-components-prod";
import Blockquote from "./components/Blockquote";

interface Props {
  isOpen: boolean;
  isManyError: boolean;
}

const ModalErrorServer = ({ isOpen, isManyError }: Props) => {
  const handleReload = () => {
    localStorage.removeItem("DTransaction");
    localStorage.removeItem("DTransaction_status");
    window.location.reload();
  };

  return (
    <div className="flex justify-center mb-xxlg">
      <CcModal visible={isOpen} hideCloseButton>
        <div className="mb-lg">
          <h2 className="font-black text-heading-02 text-color-02 mb-lg text-center">
            Tuvimos un problema al cargar la página
          </h2>
          <p className="text-center text-color-02">
            Te pedimos volver a actualizarla
          </p>
        </div>
        <div className="flex justify-center gap-lg mt-14 modal-buttons">
          <Button
            text="Actualizar página"
            color="primary"
            className="w-full"
            data-testid="btn-reload"
            onClick={handleReload}
          />
        </div>
        <div className={!isManyError ? "hidden" : ""}>
          <Blockquote />
        </div>
      </CcModal>
    </div>
  );
};

export default ModalErrorServer;
